// ── Share utility ─────────────────────────────────────────────────────────────

export function showShare(item, url) {
    const btn = document.getElementById('share-btn');
    if (!btn) return;
    btn.style.display = '';
    btn.onclick = () => _doShare(btn, item, url);
}

export function hideShare() {
    const btn = document.getElementById('share-btn');
    if (!btn) return;
    btn.style.display = 'none';
    btn.onclick = null;
}

async function _doShare(btn, item, url) {
    const metaDesc = document.querySelector('meta[name="description"]')?.content || '';

    if (navigator.share) {
        try {
            await navigator.share({ title: item.title || '', text: metaDesc, url });
        } catch (e) { /* user cancelled */ }
        return;
    }

    // Desktop: copy to clipboard and flash feedback
    try {
        await navigator.clipboard.writeText(url);
    } catch {
        const ta = document.createElement('textarea');
        ta.value = url;
        ta.style.cssText = 'position:fixed;opacity:0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
    }
    const orig = btn.textContent;
    btn.textContent = 'Copied';
    setTimeout(() => { btn.textContent = orig; }, 1500);
}
